import { useOnlineStatus } from "../../hooks/useOnlineStatus";

export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 w-full bg-amber-500 px-3 py-1 text-center text-xs font-medium text-slate-900"
    >
      Sin conexión — los marcadores nuevos se guardarán localmente y se
      sincronizarán al volver.
    </div>
  );
}
